import { z } from "zod";
export const PageBlockContextConnection = z.enum([
    "cursor",
    "claudeCode",
    "vsCode",
    "codex",
    "codeSnippet",
    "url",
]);
